(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    function textOf(element, selector) {
      var target = element.querySelector(selector);
      return target ? target.textContent.toLowerCase() : '';
    }

    function productText(card) {
      return [
        textOf(card, '.product-title'),
        card.getAttribute('data-product-type') || '',
        card.getAttribute('data-product-tags') || ''
      ].join(' ').toLowerCase();
    }

    function scoreCard(card, collectionHandle) {
      var text = productText(card);
      var score = 0;

      if (text.indexOf('best seller') > -1 || text.indexOf('sale') > -1) score -= 8;

      if (collectionHandle === 'artificial-flowers') {
        if (/rose|hydrangea|orchid|peony|tulip|lily|carnation|daisy|dogwood|blossom|cherry blossom|baby.?s breath|amaryllis|flower|floral|bouquet|stem|spray|branch/.test(text)) score -= 60;
        if (/category_artificial_flowers|artificial flower stem|rose|orchid|hydrangea|bouquet|cherry blossom/.test(text)) score -= 30;
        if (/wreath|garland|tree|ficus|fern|plant|succulent|ivy|eucalyptus|boxwood|topiary|berry|christmas|holiday/.test(text)) score += 140;
        if (/cutter|cleaner|tool|wire|foam|container|vase|pot|planter/.test(text)) score += 110;
      }

      if (collectionHandle === 'trees-and-plants') {
        if (/tree|plant|fern|ficus|succulent|ivy|eucalyptus|boxwood|topiary|greenery|category_trees|category_faux_plants/.test(text)) score -= 60;
        if (/rose|bouquet|wreath|garland|christmas|berry/.test(text)) score += 70;
      }

      if (collectionHandle === 'front-door-wreaths') {
        if (/wreath|door decor|grapevine|category_wreaths/.test(text)) score -= 70;
        if (/tree|plant|fern|rose|bouquet|stem|spray/.test(text)) score += 65;
      }

      if (collectionHandle === 'bouquets') {
        if (/bouquet|arrangement|vase|centerpiece|category_arrangements_bouquets/.test(text)) score -= 70;
        if (/tree|plant|fern|wreath|garland/.test(text)) score += 70;
      }

      if (collectionHandle === 'outdoor-uv-treated') {
        if (/uv|uv.?resistant|outdoor|all.?weather|weather|indoor.?outdoor|porch|patio|front door|planter|window box|garden|category_outdoor_uv|use_outdoor/.test(text)) score -= 90;
        if (/geranium|fern|boxwood|topiary|wreath|garland|hanging|greenery/.test(text)) score -= 25;
        if (/delicate|indoor only|ceramic vase|office desk|hostess|sympathy|christmas|holiday|ornament|gift box/.test(text)) score += 90;
      }

      if (collectionHandle === 'best-sellers') {
        if (/hydrangea|rose|orchid|arrangement|bouquet|wreath|fern|ficus|ivy|geranium|carnation|flower|plant/.test(text)) score -= 45;
        if (/christmas|holiday|ornament|gift box|tool|cutter|wire|foam|cleaner/.test(text)) score += 80;
      }

      if (collectionHandle === 'hydrangeas-1' || collectionHandle === 'artificial-hydrangeas') {
        if (/hydrangea|snowball/.test(text)) score -= 85;
        if (/rose|orchid|carnation|poinsettia|holly|christmas|fern|ficus|tool/.test(text)) score += 95;
      }

      if (collectionHandle === 'roses' || collectionHandle === 'artificial-roses') {
        if (/rose|rosebud/.test(text)) score -= 85;
        if (/hydrangea|orchid|carnation|poinsettia|holly|christmas|fern|ficus|tool/.test(text)) score += 95;
      }

      if (collectionHandle === 'orchids' || collectionHandle === 'artificial-orchids') {
        if (/orchid|phalaenopsis|cymbidium/.test(text)) score -= 85;
        if (/hydrangea|rose|carnation|poinsettia|holly|christmas|fern|ficus|tool/.test(text)) score += 95;
      }

      if (collectionHandle === 'geraniums') {
        if (/geranium/.test(text)) score -= 90;
        if (/hydrangea|rose|orchid|poinsettia|holly|christmas|fern|ficus|tool/.test(text)) score += 95;
      }

      if (collectionHandle === 'garlands') {
        if (/garland|vine|swag/.test(text)) score -= 85;
        if (/single stem|bush|wreath|tree|tool|cutter/.test(text)) score += 85;
      }

      return score;
    }

    function currentSortBy() {
      return new URLSearchParams(window.location.search).get('sort_by') || '';
    }

    function parseMoney(text) {
      var match = String(text || '').replace(/,/g, '').match(/\$?\s*(\d+(?:\.\d{1,2})?)/);
      return match ? parseFloat(match[1]) : Number.POSITIVE_INFINITY;
    }

    function productCardPrice(item) {
      var priceSource = item.querySelector('.price-box .special-price, .price-box [data-price-grid], .price-box .price-regular span');
      if (priceSource) return parseMoney(priceSource.textContent);

      var priceBox = item.querySelector('.price-box');
      if (!priceBox) return Number.POSITIVE_INFINITY;

      var prices = String(priceBox.textContent || '').replace(/,/g, '').match(/\$\s*\d+(?:\.\d{1,2})?/g) || [];
      if (!prices.length) return Number.POSITIVE_INFINITY;
      return Math.min.apply(null, prices.map(parseMoney));
    }

    function sortProductsByVisiblePrice(grid, direction) {
      var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-item'));
      if (items.length < 2) return false;

      items
        .map(function (item, index) {
          return {
            item: item,
            index: index,
            price: productCardPrice(item)
          };
        })
        .sort(function (a, b) {
          if (a.price === b.price) return a.index - b.index;
          return direction === 'desc' ? b.price - a.price : a.price - b.price;
        })
        .forEach(function (entry) {
          grid.appendChild(entry.item);
        });

      return true;
    }

    function sortVisibleCollectionProducts() {
      var pathMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      if (!pathMatch) return;

      var collectionHandle = pathMatch[1];
      var supportedCollections = [
        'artificial-flowers',
        'trees-and-plants',
        'front-door-wreaths',
        'bouquets',
        'outdoor-uv-treated',
        'best-sellers',
        'hydrangeas-1',
        'artificial-hydrangeas',
        'roses',
        'artificial-roses',
        'orchids',
        'artificial-orchids',
        'geraniums',
        'garlands'
      ];
      if (supportedCollections.indexOf(collectionHandle) === -1) return;

      var grid = document.querySelector('.product-collection.products-grid');
      if (!grid || grid.getAttribute('data-af-sorted') === 'true') return;

      var sortBy = currentSortBy();
      if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
        if (sortProductsByVisiblePrice(grid, sortBy === 'price-descending' ? 'desc' : 'asc')) {
          grid.setAttribute('data-af-sorted', 'true');
        }
        return;
      }

      var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-item'));
      if (items.length < 2) return;

      items
        .map(function (item, index) {
          var card = item.querySelector('.product-item') || item;
          return {
            item: item,
            index: index,
            score: scoreCard(card, collectionHandle)
          };
        })
        .sort(function (a, b) {
          if (a.score === b.score) return a.index - b.index;
          return a.score - b.score;
        })
        .forEach(function (entry) {
          grid.appendChild(entry.item);
        });

      grid.setAttribute('data-af-sorted', 'true');
    }

    function curateBestSellersCollection() {
      var pathMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      if (!pathMatch || pathMatch[1] !== 'best-sellers') return;

      var grid = document.querySelector('.product-collection.products-grid');
      if (!grid || grid.getAttribute('data-af-curated') === 'true') return;

      var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-item'));
      if (items.length < 2) return;

      var arrangementCount = 0;
      var orchidCount = 0;
      var roseSprayCount = 0;
      var familySeen = {};

      items.forEach(function (item) {
        var card = item.querySelector('.product-item') || item;
        var title = textOf(card, '.product-title').replace(/\s+/g, ' ').trim();
        var family = title
          .replace(/\b(white|cream|pink|red|blue|burgundy|green|black|yellow|purple|orange|apricot)\b/g, '')
          .replace(/\b(set of|pack of|box of)\s*\d+\b/g, '')
          .replace(/\b\d+(\.\d+)?\s*(inch|in|\"|ft|feet|head|heads|spray|sprays|stem|stems|pc|pcs|piece|pieces)\b/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim()
          .split(' ')
          .slice(0, 7)
          .join(' ');
        var isArrangement = /arrangement|vase|bouquet|orchid|phalaenopsis/.test(title);
        var isOrchid = /orchid|phalaenopsis/.test(title);
        var isRoseSpray = /rose spray|rose with 4/.test(title);
        var isSeasonal = /christmas|holiday|pre-lit|ornament|gift box|holly|poinsettia/.test(title);
        var shouldHide = false;

        if (isSeasonal) {
          shouldHide = true;
        } else if (family && familySeen[family]) {
          shouldHide = true;
        } else if (isOrchid && orchidCount >= 2) {
          shouldHide = true;
        } else if (isArrangement && arrangementCount >= 5) {
          shouldHide = true;
        } else if (isRoseSpray && roseSprayCount >= 1) {
          shouldHide = true;
        }

        if (shouldHide) {
          item.hidden = true;
          item.classList.add('af-product-hidden-duplicate');
          return;
        }

        if (family) familySeen[family] = true;
        if (isArrangement) arrangementCount += 1;
        if (isOrchid) orchidCount += 1;
        if (isRoseSpray) roseSprayCount += 1;
      });

      grid.setAttribute('data-af-curated', 'true');
    }

    function bindReliableSortNavigation() {
      document.addEventListener('click', function (event) {
        var target = event.target.closest('.filter-sortby .dropdown-menu [data-href]');
        if (!target) return;

        var sortBy = target.getAttribute('data-href');
        if (!sortBy) return;

        event.preventDefault();
        event.stopPropagation();

        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortBy);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        window.location.href = url.pathname + '?' + url.searchParams.toString() + url.hash;
      }, true);
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function productImage(product) {
      if (product && product.images && product.images.length && product.images[0].src) return product.images[0].src;
      if (product && product.image && product.image.src) return product.image.src;
      return '';
    }

    function productAvailable(product) {
      if (!product || !product.variants || !product.variants.length) return true;
      return product.variants.some(function (variant) {
        return variant.available !== false;
      });
    }

    function productMinPrice(product) {
      if (!product || !product.variants || !product.variants.length) return '';
      var prices = product.variants.map(function (variant) {
        return Number(variant.price || 0);
      }).filter(function (price) {
        return !isNaN(price);
      });
      if (!prices.length) return '';
      return '$' + Math.min.apply(Math, prices).toFixed(2);
    }

    function buildFavoriteCard(product) {
      var image = productImage(product);
      var link = '/products/' + product.handle;
      var title = product.title || 'Artificial flowers';
      var price = productMinPrice(product);
      var card = document.createElement('a');
      card.className = 'af-more-favorite-card';
      card.href = link;
      card.innerHTML = [
        '<span class="af-more-favorite-card__image">',
        image ? '<img loading="lazy" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '">' : '',
        '</span>',
        '<strong>' + escapeHtml(title) + '</strong>',
        price ? '<span>' + escapeHtml(price) + '</span>' : ''
      ].join('');
      return card;
    }

    function loadMoreBestSellers() {
      var pathMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      if (!pathMatch || pathMatch[1] !== 'best-sellers') return;

      var section = document.querySelector('[data-af-more-favorites]');
      var grid = document.querySelector('[data-af-more-favorites-grid]');
      if (!section || !grid || grid.getAttribute('data-af-loaded') === 'true') return;

      var collectionHandles = ['artificial-flowers', 'hydrangeas-1', 'roses', 'bouquets', 'front-door-wreaths', 'trees-and-plants'];
      var existingHandles = Array.prototype.slice.call(document.querySelectorAll('.product-item a[href*="/products/"], .product-title[href*="/products/"]'))
        .map(function (link) {
          var match = link.href.match(/\/products\/([^/?#]+)/);
          return match ? match[1] : '';
        })
        .filter(Boolean);
      var seen = existingHandles.reduce(function (map, handle) {
        map[handle] = true;
        return map;
      }, {});

      Promise.all(collectionHandles.map(function (handle) {
        return fetch('/collections/' + handle + '/products.json?limit=18')
          .then(function (response) { return response.ok ? response.json() : { products: [] }; })
          .catch(function () { return { products: [] }; });
      })).then(function (responses) {
        var products = [];
        responses.forEach(function (response) {
          (response.products || []).forEach(function (product) {
            var haystack = [product.title, product.product_type, (product.tags || []).join(' ')].join(' ').toLowerCase();
            if (seen[product.handle]) return;
            if (!productAvailable(product)) return;
            if (/christmas|holiday|ornament|gift box|tool|cutter|wire|foam|cleaner/.test(haystack)) return;
            seen[product.handle] = true;
            products.push(product);
          });
        });

        products.slice(0, 24).forEach(function (product) {
          grid.appendChild(buildFavoriteCard(product));
        });

        if (grid.children.length) {
          section.hidden = false;
          grid.setAttribute('data-af-loaded', 'true');
        }
      });
    }

    function injectFinalMobilePlpCss() {
      if (document.getElementById('af-final-mobile-plp-css')) return;

      var style = document.createElement('style');
      style.id = 'af-final-mobile-plp-css';
      style.textContent = [
        '@media (max-width: 767px) {',
        'body.template-collection.layout_style_flower .product-collection.products-grid .grid-item .product-item .product-bottom .product-title,',
        'body.template-collection.layout_style_flower .product-collection.products-grid .grid-item .product-item .product-bottom .product-title a,',
        'body.template-collection.layout_style_flower .products-grid .grid-item .product-item .product-bottom .product-title,',
        'body.template-collection.layout_style_flower .products-grid .grid-item .product-item .product-bottom .product-title a,',
        'body.template-search.layout_style_flower .product-search.products-grid .grid-item .product-item .product-bottom .product-title,',
        'body.template-search.layout_style_flower .product-search.products-grid .grid-item .product-item .product-bottom .product-title a,',
        'body.template-search.layout_style_flower .products-grid .grid-item .product-item .product-bottom .product-title,',
        'body.template-search.layout_style_flower .products-grid .grid-item .product-item .product-bottom .product-title a {',
        'font-size: 14px !important;',
        'line-height: 1.35 !important;',
        'font-weight: 600 !important;',
        'letter-spacing: 0 !important;',
        'color: #17231e !important;',
        'overflow-wrap: anywhere !important;',
        'word-break: normal !important;',
        'text-align: left !important;',
        '}',
        'body.template-collection.layout_style_flower .product-collection.products-grid .grid-item .product-item .product-bottom,',
        'body.template-collection.layout_style_flower .products-grid .grid-item .product-item .product-bottom,',
        'body.template-search.layout_style_flower .product-search.products-grid .grid-item .product-item .product-bottom,',
        'body.template-search.layout_style_flower .products-grid .grid-item .product-item .product-bottom {',
        'gap: 7px !important;',
        '}',
        'body.template-collection.layout_style_flower .product-collection.products-grid .grid-item .product-item .price-box,',
        'body.template-collection.layout_style_flower .products-grid .grid-item .product-item .price-box,',
        'body.template-search.layout_style_flower .product-search.products-grid .grid-item .product-item .price-box,',
        'body.template-search.layout_style_flower .products-grid .grid-item .product-item .price-box {',
        'font-size: 15px !important;',
        'line-height: 1.25 !important;',
        '}',
        'body.template-collection.layout_style_flower .af-google-ads-landing,',
        'body.template-collection.layout_style_flower .af-more-favorites,',
        'body.template-search.layout_style_flower .af-google-ads-landing,',
        'body.template-search.layout_style_flower .af-more-favorites,',
        'body.template-collection.layout_style_flower .halo-collection-content,',
        'body.template-search.layout_style_flower .halo-collection-content {',
        'scroll-margin-top: 142px !important;',
        '}',
        'body.template-collection.layout_style_flower #accept-cookies,',
        'body.template-search.layout_style_flower #accept-cookies,',
        'body.template-index.layout_style_flower #accept-cookies {',
        'position: fixed !important;',
        'left: 8px !important;',
        'right: auto !important;',
        'bottom: 8px !important;',
        'width: auto !important;',
        'max-width: 205px !important;',
        'min-width: 0 !important;',
        'padding: 8px 10px !important;',
        'border-radius: 6px !important;',
        'font-size: 11px !important;',
        'line-height: 1.25 !important;',
        'z-index: 60 !important;',
        '}',
        'body.template-product.layout_style_flower .sticky_form {',
        'display: none !important;',
        '}',
        'body.template-product.layout_style_flower .breadcrumb {',
        'display: none !important;',
        '}',
        'body.template-product.layout_style_flower .slider-nav,',
        'body.template-product.layout_style_flower .product-single__compareColor {',
        'display: none !important;',
        '}',
        'body.template-product.layout_style_flower .product-shop {',
        'padding: 0 10px 28px !important;',
        '}',
        'body.template-product.layout_style_flower .product-title,',
        'body.template-product.layout_style_flower .product-title h1,',
        'body.template-product.layout_style_flower h1.product-title {',
        'font-size: 21px !important;',
        'line-height: 1.18 !important;',
        'letter-spacing: 0 !important;',
        'margin: 0 0 7px !important;',
        'color: #17231e !important;',
        '}',
        'body.template-product.layout_style_flower form[action*="/cart/add"] {',
        'margin-top: 10px !important;',
        '}',
        'body.template-product.layout_style_flower .product-shop .groups-btn {',
        'position: static !important;',
        'display: block !important;',
        'margin-top: 12px !important;',
        '}',
        'body.template-product.layout_style_flower .product-shop .groups-btn button,',
        'body.template-product.layout_style_flower .product-shop .btn,',
        'body.template-product.layout_style_flower .product-shop button[name="add"] {',
        'width: 100% !important;',
        'min-height: 48px !important;',
        'border-radius: 6px !important;',
        'font-size: 14px !important;',
        '}',
        '}'
      ].join('');
      document.head.appendChild(style);
    }

    function injectListingCardCss() {
      if (document.getElementById('af-listing-card-css')) return;

      var style = document.createElement('style');
      style.id = 'af-listing-card-css';
      style.textContent = [
        'body.template-collection.layout_style_flower .product-collection.products-grid > .grid-item,',
        'body.template-collection.layout_style_flower .products-grid > .grid-item,',
        'body.template-search.layout_style_flower .product-search.products-grid > .grid-item,',
        'body.template-search.layout_style_flower .products-grid > .grid-item {',
        'display: flex !important;',
        'flex-direction: column !important;',
        '}',
        'body.template-collection.layout_style_flower .product-collection.products-grid > .grid-item > .product-item,',
        'body.template-collection.layout_style_flower .products-grid > .grid-item > .product-item,',
        'body.template-search.layout_style_flower .product-search.products-grid > .grid-item > .product-item,',
        'body.template-search.layout_style_flower .products-grid > .grid-item > .product-item {',
        'display: flex !important;',
        'flex-direction: column !important;',
        'width: 100% !important;',
        'height: 100% !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .inner-top,',
        'body.template-search.layout_style_flower .product-item .inner-top {',
        'display: flex !important;',
        'flex: 1 1 auto !important;',
        'flex-direction: column !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .product-bottom,',
        'body.template-search.layout_style_flower .product-item .product-bottom {',
        'display: flex !important;',
        'flex: 0 0 240px !important;',
        'height: 240px !important;',
        'min-height: 240px !important;',
        'flex-direction: column !important;',
        'overflow: visible !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .product-bottom > .appio-rating-badge,',
        'body.template-search.layout_style_flower .product-item .product-bottom > .appio-rating-badge {',
        'display: none !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .wrapper-compare,',
        'body.template-search.layout_style_flower .product-item .wrapper-compare {',
        'min-height: 54px !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .product-title,',
        'body.template-collection.layout_style_flower .product-item .product-title a,',
        'body.template-search.layout_style_flower .product-item .product-title,',
        'body.template-search.layout_style_flower .product-item .product-title a {',
        'display: -webkit-box !important;',
        'min-height: 46px !important;',
        'max-height: 66px !important;',
        'overflow: hidden !important;',
        '-webkit-box-orient: vertical !important;',
        '-webkit-line-clamp: 3 !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .price-box,',
        'body.template-search.layout_style_flower .product-item .price-box {',
        'margin-top: auto !important;',
        'margin-bottom: 12px !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .action.af-card-action,',
        'body.template-search.layout_style_flower .product-item .action.af-card-action {',
        'display: flex !important;',
        'align-items: center !important;',
        'justify-content: center !important;',
        'width: 100% !important;',
        'min-height: 58px !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .action.af-card-action form.variants,',
        'body.template-search.layout_style_flower .product-item .action.af-card-action form.variants {',
        'display: flex !important;',
        'align-items: center !important;',
        'justify-content: center !important;',
        'width: 100% !important;',
        'height: 100% !important;',
        'padding-top: 0 !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .action.af-card-action .btn,',
        'body.template-search.layout_style_flower .product-item .action.af-card-action .btn {',
        'display: flex !important;',
        'align-items: center !important;',
        'justify-content: center !important;',
        'width: 100% !important;',
        'min-height: 48px !important;',
        'padding-top: 0 !important;',
        'padding-bottom: 0 !important;',
        '}',
        '@media (max-width: 767px) {',
        'body.template-collection.layout_style_flower .product-item .product-bottom,',
        'body.template-search.layout_style_flower .product-item .product-bottom {',
        'flex-basis: 260px !important;',
        'height: 260px !important;',
        'min-height: 260px !important;',
        '}',
        'body.template-collection.layout_style_flower .product-item .product-title,',
        'body.template-collection.layout_style_flower .product-item .product-title a,',
        'body.template-search.layout_style_flower .product-item .product-title,',
        'body.template-search.layout_style_flower .product-item .product-title a {',
        'min-height: 58px !important;',
        'max-height: 58px !important;',
        '}',
        '}'
      ].join('');
      document.head.appendChild(style);
    }

    function injectProductTrustCss() {
      if (document.getElementById('af-product-trust-css')) return;

      var style = document.createElement('style');
      style.id = 'af-product-trust-css';
      style.textContent = [
        'body.template-product.layout_style_flower .af-product-benefit-line {',
        'display: flex !important;',
        'flex-wrap: wrap !important;',
        'gap: 7px !important;',
        'margin: 8px 0 10px !important;',
        '}',
        'body.template-product.layout_style_flower .af-product-benefit-line span {',
        'display: inline-flex !important;',
        'align-items: center !important;',
        'min-height: 30px !important;',
        'padding: 0 10px !important;',
        'border: 1px solid #d8c8b5 !important;',
        'border-radius: 999px !important;',
        'background: #fffaf4 !important;',
        'color: #173f32 !important;',
        'font-size: 12px !important;',
        'font-weight: 800 !important;',
        'line-height: 1.2 !important;',
        '}',
        'body.template-product.layout_style_flower .af-product-trust-row {',
        'display: grid !important;',
        'grid-template-columns: repeat(3, minmax(0, 1fr)) !important;',
        'gap: 8px !important;',
        'margin: 10px 0 12px !important;',
        '}',
        'body.template-product.layout_style_flower .af-product-trust-row span {',
        'display: flex !important;',
        'align-items: center !important;',
        'justify-content: center !important;',
        'min-height: 42px !important;',
        'padding: 7px 9px !important;',
        'border: 1px solid #e1d3bf !important;',
        'border-radius: 7px !important;',
        'background: #fff !important;',
        'color: #23372f !important;',
        'font-size: 12px !important;',
        'font-weight: 850 !important;',
        'line-height: 1.2 !important;',
        'text-align: center !important;',
        '}',
        '@media (max-width: 767px) {',
        'body.template-product.layout_style_flower .af-product-benefit-line {',
        'gap: 6px !important;',
        'margin: 6px 0 8px !important;',
        '}',
        'body.template-product.layout_style_flower .af-product-benefit-line span {',
        'min-height: 28px !important;',
        'padding: 0 8px !important;',
        'font-size: 11px !important;',
        '}',
        'body.template-product.layout_style_flower .af-product-trust-row {',
        'grid-template-columns: 1fr !important;',
        'gap: 6px !important;',
        'margin: 8px 0 10px !important;',
        '}',
        'body.template-product.layout_style_flower .af-product-trust-row span {',
        'min-height: 34px !important;',
        'font-size: 11px !important;',
        '}',
        '}'
      ].join('');
      document.head.appendChild(style);
    }

    function insertAfter(referenceNode, newNode) {
      if (!referenceNode || !referenceNode.parentNode) return false;
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
      return true;
    }

    function addProductTrustCallouts() {
      if (!document.body.classList.contains('template-product') || !document.body.classList.contains('layout_style_flower')) return;

      var shop = document.querySelector('.product-shop');
      if (!shop || shop.querySelector('.af-product-benefit-line')) return;

      var titleNode = shop.querySelector('.product-title h1, h1.product-title, .product-title');
      var titleText = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : 'Artificial flowers';
      var titleBlock = titleNode ? (titleNode.closest('.product-title') || titleNode) : null;

      var benefitLine = document.createElement('div');
      benefitLine.className = 'af-product-benefit-line';
      benefitLine.setAttribute('aria-label', 'Product benefits');
      benefitLine.innerHTML = [
        '<span>Realistic faux floral styling</span>',
        '<span>No watering or wilting</span>',
        '<span>Easy to shape after unpacking</span>'
      ].join('');

      if (!insertAfter(titleBlock, benefitLine)) {
        shop.insertBefore(benefitLine, shop.firstChild);
      }

      var trustRow = document.createElement('div');
      trustRow.className = 'af-product-trust-row';
      trustRow.setAttribute('aria-label', 'Store trust details');
      trustRow.innerHTML = [
        '<span>Free U.S. shipping</span>',
        '<span>30-day returns</span>',
        '<span>Ships from Hackensack, NJ</span>'
      ].join('');

      var priceBlock = shop.querySelector('.prices, .price-box, .product-price, [data-price-wrapper], .price');
      if (!insertAfter(priceBlock, trustRow)) {
        insertAfter(benefitLine, trustRow);
      }

      Array.prototype.slice.call(document.querySelectorAll('body.template-product img')).forEach(function (image) {
        if ((image.getAttribute('alt') || '').trim()) return;
        image.setAttribute('alt', 'Realistic artificial flowers - ' + titleText);
      });
    }

    function applyMobileProductFixes() {
      if (!document.body.classList.contains('template-product') || !document.body.classList.contains('layout_style_flower')) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;

      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 390;
      var galleryHeight = Math.min(viewportWidth, 285);

      function setImportant(element, property, value) {
        if (!element) return;
        element.style.setProperty(property, value, 'important');
      }

      function setAll(selector, properties) {
        Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (element) {
          Object.keys(properties).forEach(function (property) {
            setImportant(element, property, properties[property]);
          });
        });
      }

      setAll('.product_top', {
        display: 'block'
      });
      setAll('.product-photos', {
        height: 'auto',
        'min-height': '0',
        'max-height': 'none',
        'flex-basis': 'auto',
        margin: '0 0 12px'
      });
      setAll('.product-img-box, .wrapper-images, .product-photo-container.slider-for, .product-photo-container.slider-for .slick-list, .product-photo-container.slider-for .slick-track, .product-photo-container.slider-for .slick-slide', {
        height: galleryHeight + 'px',
        'min-height': '0',
        'max-height': galleryHeight + 'px'
      });
      setAll('.product-img-box', {
        overflow: 'visible',
        margin: '0 0 12px'
      });
      setAll('.product-photo-container.slider-for .fancybox, .product-photo-container.slider-for img', {
        height: galleryHeight + 'px',
        width: '100%',
        'object-fit': 'contain'
      });
    }

    function applyMobileOverlayFixes() {
      // The cookie section owns its normal-flow placement on all screen sizes.
    }

    injectFinalMobilePlpCss();
    injectListingCardCss();
    injectProductTrustCss();
    addProductTrustCallouts();
    applyMobileOverlayFixes();
    applyMobileProductFixes();
    window.setTimeout(applyMobileOverlayFixes, 600);
    window.setTimeout(applyMobileOverlayFixes, 1800);
    window.setTimeout(applyMobileProductFixes, 600);
    window.setTimeout(applyMobileProductFixes, 1800);
    window.setTimeout(applyMobileProductFixes, 3200);
    window.setTimeout(addProductTrustCallouts, 800);
    window.addEventListener('resize', applyMobileProductFixes);

    bindReliableSortNavigation();
    sortVisibleCollectionProducts();
    curateBestSellersCollection();
    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('.sidebar-label');
      if (openButton && document.querySelector('#main-collection-filters')) {
        event.preventDefault();
        document.documentElement.classList.add('af-filter-open');
        document.body.classList.add('af-filter-open');
      }

      var closeButton = event.target.closest('.close-sidebar, .af-filter-scrim');
      if (closeButton) {
        event.preventDefault();
        document.documentElement.classList.remove('af-filter-open');
        document.body.classList.remove('af-filter-open');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        document.documentElement.classList.remove('af-filter-open');
        document.body.classList.remove('af-filter-open');
      }
    });
  });
  var afCartBusy = false;
  var afCartQuantitySelector = '.wrapper-cart-template .update-cart--template, #dropdown-cart .item-quantity';
  function afChangeCartItem(item, quantity) {
    if (afCartBusy) return;
    afCartBusy = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var controls = Array.from(document.querySelectorAll(afCartQuantitySelector + ', .wrapper-cart-template [name="checkout"]'));
    var states = controls.map(function (control) { return control.disabled; });
    controls.forEach(function (control) { control.disabled = true; });
    item.setAttribute('aria-busy', 'true');
    var errorBox = item.querySelector('[data-af-cart-error]');
    if (errorBox) errorBox.remove();
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: item.getAttribute('data-key'), quantity: quantity })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || 'Unable to update your cart. Please try again.');
        window.location.reload();
      });
    }).catch(function (error) {
      afCartBusy = false;
      item.removeAttribute('aria-busy');
      controls.forEach(function (control, index) { control.disabled = states[index]; });
      item.querySelectorAll('input[type="number"]').forEach(function (input) { input.value = input.defaultValue; });
      var message = document.createElement('p');
      message.setAttribute('data-af-cart-error', '');
      message.setAttribute('role', 'alert');
      message.textContent = error.message || 'Unable to update your cart. Please try again.';
      item.appendChild(message);
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('#dropdown-cart .btn-remove, .wrapper-cart-template .remove');
    if (!button) return;
    var item = button.closest('[data-key]');
    if (!item || !item.getAttribute('data-key')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    afChangeCartItem(item, 0);
  }, true);
  document.addEventListener('change', function (event) {
    var input = event.target.closest(afCartQuantitySelector);
    if (!input) return;
    var item = input.closest('[data-key]');
    if (!item || !item.getAttribute('data-key')) return;
    event.stopImmediatePropagation();
    var quantity = Number(input.value);
    if (!input.value.trim() || !Number.isSafeInteger(quantity) || quantity < 0) {
      input.value = input.defaultValue;
      return;
    }
    item.querySelectorAll('input[type="number"]').forEach(function (other) { other.value = quantity; });
    afChangeCartItem(item, quantity);
  }, true);
  document.addEventListener('submit', function (event) {
    if (afCartBusy && event.target.matches('.wrapper-cart-template')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
